<template>
  <div class="page-container">
    <!--工具栏-->
    <el-scrollbar>
      <el-form
        :inline="true"
        :model="filters"
        class="demo-form-inline toolbar"
        style="padding-bottom: 0px"
        :size="size"
      >
        <el-form-item label="姓名">
          <el-input
            v-model.trim="filters.oldmanName"
            placeholder="请输入姓名"
            style="width:150px"
            clearable
            @keyup.enter.native.prevent="enterSearchMember"
          ></el-input>
        </el-form-item>
        <el-form-item label="下单日期">
          <el-date-picker
            :editable="false"
            style="width:200px"
            v-model="filters.startQueryTime"
            unlink-panels
            type="daterange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            clearable
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="pickerInspectDate"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="订单状态">
          <el-select v-model="filters.stat" clearable placeholder="请选择" style="width:120px">
            <el-option
              v-for="item in orderStatusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="el-icon-search"
            label="查询"
            type="primary"
            @click="findPage(filters)"
          />
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="el-icon-plus"
            label="新增"
            type="warning"
            @click="handleAdd"
          />
        </el-form-item>
        <!-- <el-form-item>
          <kt-button
            icon="el-icon-plus"
            label="全部新增"
            type="warning"
            @click="handAddAll"
          />
        </el-form-item> -->
        <el-form-item>
          <kt-button
            icon="el-icon-refresh"
            label="刷新"
            type="primary"
            @click="handleRefresh"
          />
        </el-form-item>

      </el-form>
    </el-scrollbar>
    <!--表格内容栏-->
    <kt-table
      v-loading="loading"
      :height="'400'"
      element-loading-text="拼命加载中"
      :data="pageResult"
      :columns="filterColumns"
      :operationWidth="190"
      :showEdit="false"
      :showDelete="false"
      :showCancel="true"
      :showLook="true"
      :statusWidth="100"
      :showStatus="true"
      @findPage="findPage"
      @handleCancel="handleCancel"
      @handleLook="handleLook"
      @refreshPageRequest="refreshPageRequest"
      @handleNotSure="handleNotSure"
    >
    </kt-table>

    <!-- 新增和修改的dialog-->
    <el-dialog
      class="volunteerdialog"
      :title="operation ? '新建订单' : '修改订单'"
      width="36%"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      center
    >
      <el-form
        class="volunteerdialogform"
        :model="dataForm"
        label-width="150px"
        :rules="dataFormRules"
        ref="dataForm"
        :size="size"
        label-position="right"
      >
        <el-form-item label="老人姓名:" prop="oldName" class="oldmanName">
          <el-autocomplete
            v-model.trim="dataForm.oldName"
            auto-complete="off"
            placeholder="模糊搜索老人姓名"
            style="width: 70%"
            :fetch-suggestions="querySearchAsync"
            @select="handleOlderSelect"
          ></el-autocomplete>
        </el-form-item>
        <el-form-item label="身份证号码:">
          <span>{{ currentOlder.oldIdCard }}</span>
        </el-form-item>
        <el-form-item label="电话号码:">
          <span>{{ currentOlder.oldPhone }}</span>
        </el-form-item>
        <el-form-item label="监护人:">
          <span>{{ currentOlder.egNamea }}</span>
        </el-form-item>
        <el-form-item label="与老人关系:">
          <span v-if="currentOlder.relationshipa == 0">夫妻</span>
          <span v-else-if="currentOlder.relationshipa == 1">子女</span>
          <span v-else-if="currentOlder.relationshipa == 2">兄弟</span>
          <span v-else-if="currentOlder.relationshipa == 3">朋友</span>
          <span v-else-if="currentOlder.relationshipa == 5">其他</span>
          <span v-else></span>
        </el-form-item>
        <el-form-item label="联系方式:">
          <span>{{ currentOlder.egPhonea }}</span>
        </el-form-item>
        <el-form-item
          label="家庭住址:"
          prop="serviceAddress"
          class="serviceAddress"
        >
          <el-input
            v-model.trim="dataForm.serviceAddress"
            placeholder="输入家庭住址"
            style="width: 70%"
          ></el-input>
        </el-form-item>
        <el-form-item label="开始时间:" prop="serviceTime" class="serviceTime">
          <el-date-picker
            style="width: 70%"
            v-model="dataForm.serviceTime"
            type="datetime"
            @change="timeChange"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="pickerOptionsStart"
            placeholder="选择日期时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="服务项目:" prop="serviceId" class="serviceId">
          <el-select
            v-model="dataForm.serviceId"
            placeholder="请选择服务项目"
            style="width: 70%"
            @change="serviceItemChange"
          >
            <el-option
              v-for="item in serviceItemsOptions"
              :key="item.id"
              :label="item.serviceName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="服务内容:"
          class="servicecontent"
          style="margin-top: 10px; margin-bottom: 10px"
        >
          <el-row v-for="(item, index) in serviceContent" :key="item.id">
            {{ 1 + index }}.{{ item.itemName }}({{ item.itemContent }})
          </el-row>
        </el-form-item>
        <el-form-item
          label="服务时长:"
          v-if="currentServiceItem.serviceType == 0"
        >
          <el-select
            v-model="dataForm.serviceDuration"
            placeholder="请选择服务时长"
            style="width: 70%"
            @change="serviceDuringChange"
          >
            <el-option
              v-for="item in serviceTimeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="服务积分:">
          <span>{{ integral }}积分</span>
        </el-form-item>
        <el-form-item label="备注:">
          <el-input
            v-model="dataForm.remark"
            :maxlength="50"
            type="textarea"
            :rows="3"
            auto-complete="off"
            placeholder="请输入备注"
            style="width: 70%"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button :size="size" @click.native="dialogVisible = false"
          >取消</el-button
        >
        <el-button
          :size="size"
          type="primary"
          @click.native="submitForm"
          :loading="editLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <!-- 新增和修改的dialog-->
    <el-dialog
      class="volunteerdialog"
      title="批量新增订单"
      width="36%"
      :visible.sync="dialogAllVisible"
      :close-on-click-modal="false"
      center
    >
      <el-form
        :model="dataForm"
        label-width="150px"
        ref="dataForm"
        :size="size"
        label-position="right"
      >
        
        <el-form-item label="老人:">
          <el-checkbox-group v-model="dataForm.checkold" class="oldlist">
            <el-checkbox v-for="item in dataForm.allOld" :key="item.oldmanId" :label="item.oldmanId">{{ item.oldName }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="开始时间:" prop="serviceTime" class="serviceTime">
          <el-date-picker
            style="width: 70%"
            v-model="dataForm.serviceTime"
            type="datetime"
            @change="timeChange"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="pickerOptionsStart"
            placeholder="选择日期时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="服务项目:" prop="serviceId" class="serviceId">
          <el-select
            v-model="dataForm.serviceId"
            placeholder="请选择服务项目"
            style="width: 70%"
            @change="serviceItemChange"
          >
            <el-option
              v-for="item in serviceItemsOptions"
              :key="item.id"
              :label="item.serviceName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="服务内容:"
          class="servicecontent"
          style="margin-top: 10px; margin-bottom: 10px"
        >
          <el-row v-for="(item, index) in serviceContent" :key="item.id">
            {{ 1 + index }}.{{ item.itemName }}({{ item.itemContent }})
          </el-row>
        </el-form-item>
        <el-form-item label="服务积分:">
          <span>{{ integral }}积分</span>
        </el-form-item>
        <el-form-item label="备注:">
          <el-input
            v-model="dataForm.remark"
            :maxlength="50"
            type="textarea"
            :rows="3"
            auto-complete="off"
            placeholder="请输入备注"
            style="width: 70%"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button :size="size" @click.native="dialogAllVisible = false"
          >取消</el-button
        >
        <el-button
          :size="size"
          type="primary"
          @click.native="submitAllForm"
          :loading="editLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>
    
  </div>
</template>
<script>
import KtTable from "@/components/KtTable";
import KtButton from "@/components/KtButton";
import util from "@/utils/util.js";

export default {
  components: {
    KtTable,
    KtButton,
  },
  data() {
    return {
      loading: true,
      timePickerStart: new Date(2016, 9, 10, 18, 40),
      orderStatusOptions: [],
      serviceItemsOptions: [],
      serviceTimeOptions: [],
      size: "medium",
      currentPage: 0,
      currentOlder: {}, //当前老人
      filters: {
        oldmanName: "",
        stat: "",
        startQueryTime: "",
      },
      currentServiceItem: {},
      integral: 0,
      columns: [],
      dialogAllVisible:false,
      filterColumns: [],
      pageRequest: { pageNum: 1, pageSize: 10 },
      pageResult: {},
      dataForm: {
        oldName: "",
        serviceAddress: "",
        serviceTime: "",
        serviceId: "",
        serviceDuration: "",
        remark: "",
      },
      serviceContent: [],
      operation: false, // true:新增, false:编辑
      dialogVisible: false, // 新增编辑界面是否显示
      editLoading: false,
      dataFormRules: {
        oldName: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
          },
        ],
        serviceAddress: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
          },
          //可以设置双重验证标准
          { min: 1, max: 50, message: "长度在 1到 50 个字符" },
        ],
        serviceTime: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
          },
        ],
        serviceId: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
          },
        ],
      },
      pickerOptionsStart: {
        disabledDate(time) {
          let nowData = new Date();
          nowData = new Date(nowData.setDate(nowData.getDate() - 1));
          return time < nowData;
        },
      },
      pickerInspectDate: {
        mixTime: Date.now,
        start: Date.now,
        // disabledDate: (time) => {
        //   return time.getTime() > Date.now()
        // }
      },
      pickerServiceTime: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  methods: {
    // 刷新
    handleRefresh() {
      this.filters = {}; //清空查询条件
      this.findPage();
    },
    //键盘事件 按下键盘回车 查询
    enterSearchMember(e) {
      console.log("回车搜索", keyCode, e);
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.findPage(this.filters);
      }
    },
    //获取订单列表
    findPage(data) {
      console.log(data);
      //判断查询条件是否存在
      this.filters.oldmanName != undefined
        ? (this.pageRequest.oldmanName = this.filters.oldmanName)
        : (this.pageRequest.oldmanName = "");
      this.filters.stat != undefined
        ? (this.pageRequest.stat = this.filters.stat)
        : (this.pageRequest.stat = "");
      if (this.filters.startQueryTime) {
        this.pageRequest.startQueryTime = this.filters.startQueryTime[0];
        this.pageRequest.endQueryTime =
          this.filters.startQueryTime[1].substring(0, 10) + " 23:59:59"; //默認是00:00:00，將他修改為23:59:59
      } else {
        this.pageRequest.startQueryTime = "";
        this.pageRequest.endQueryTime = "";
      }
      console.log(this.pageRequest);
      this.$postJson("omc/order/queryListWithPage", this.pageRequest).then(
        (res) => {
          console.log(res);
          this.pageResult = res.result;
          setTimeout(() => {
            this.loading = false;
          }, 500);
          this.pageResult.list.forEach((data) => {
            switch (data.stat) {
              case 1:
                data.statue = "下单";
                break;
              case 2:
                data.statue = "待接单";
                break;
              case 3:
                data.statue = "已接单";
                break;
              case 4:
                data.statue = "取消接单";
                break;
              case 5:
                data.statue = "签到";
                break;
              case 6:
                data.statue = "签到超时";
                break;
              case 7:
                data.statue = "签退";
                break;
              case 8:
                data.statue = "签退超时";
                break;
              case 9:
                data.statue = "确认";
                break;
              case 10:
                data.statue = "确认超时";
                break;
              case 11:
                data.statue = "接单超时";
                break;
              case 12:
                data.statue = "取消下单";
                break;
            }
          });
        }
      );
    },
    getServiceList() {
      var params = {
        pageNum: 1,
        pageSize: 100,
      };
      this.$postJson("omc/service/queryListWithPage", params).then((res) => {
        console.log(res);
        this.serviceItemsOptions = res.result.list;
        console.log(this.serviceItemsOptions);
      });
    },
    timeChange(time) {
      //强行设置今天以后
      var currentDateLong = new Date(
        time.replace(new RegExp("-", "gm"), "/")
      ).getTime();
      if (currentDateLong < Date.now()) {
        var d = new Date();
        var t = d.getTime();
        t += 60000; //一个小时的毫秒数
        d = new Date(t);
        this.dataForm.serviceTime = d;
      }
    },
    // 分页刷新数据
    refreshPageRequest(data) {
      console.log(data);
      this.pageRequest.pageNum = data;
      this.findPage();
    },
    serviceDuringChange(time) {
      this.integral = this.currentServiceItem.integral * Number(time);
    },
    serviceItemChange(vId) {
      let obj = this.serviceItemsOptions.find((item) => {
        //这里的selectList就是上面遍历的数据源
        return item.id === vId; //筛选出匹配数据
      });
      this.currentServiceItem = obj;
      this.integral = this.currentServiceItem.integral;
      if (this.currentServiceItem.serviceType == 0) {
        this.dataForm.serviceDuration = 1;
      } else {
        this.dataForm.serviceDuration = 0;
      }
      //根据Id 显示服务项目
      this.serviceContent = [];
      this.$postJson("omc/serviceItem/queryListByServiceId/" + vId, {}).then(
        (res) => {
          console.log(res);
          this.serviceContent = res.result;
        }
      );
    },
    //选择服务时间
    changeServiceTime(val) {
      console.log(val);
      this.dataForm.serviceDuration = util.formatDate.format(
        new Date(val),
        "yyyy-MM-dd hh:mm:ss"
      );
      console.log(this.dataForm.serviceDuration);
    },
    //模糊搜索老人
    querySearchAsync(queryString, cb) {
      //根据 queryString 搜索
      var list = [{}];
      var param = {
        pageNo: "0",
        pageSize: "0",
        oldName: queryString,
      };
      this.$postJson("omc/Oldman/showOldManSupAll", param).then((res) => {
        console.log(res);
        if (res.result.list) {
          for (let i of res.result.list) {
            i.value = i.oldName; //将想要展示的数据作为value
          }
          list = res.result.list;
          cb(list);
        } else {
          let arr = [];
          arr.push({
            uuid: "-1",
            value: "",
          });
          cb(arr);
          setTimeout(() => {
            this.dataForm.oldName = "";
          }, 1000);
        }
      });
    },
    handleOlderSelect(item) {
      console.log(item);
      this.currentOlder = item;
      this.dataForm.serviceAddress = item.oldAddress;
      this.dataForm = Object.assign({}, this.dataForm);
    },
    handAddAll(){
      //批量新增
      this.dialogAllVisible = true;
      this.dataForm = {
        allOld:[],
        checkold:[],
        oldList:[],
        serviceTime: "",
        serviceId: "",
        remark: "",
      };
      //获取全部的老人
      //omc/Oldman/showOldManSupAll
      this.$postJson("omc/Oldman/showOldManSupAll", {
        pageNo: "1",
        pageSize: "990",
        status: 3
      }).then(
          (res) => {
            if (res.code == 200) {
                var checklist = [];
                res.result.list.forEach(item =>{
                    checklist.push(item.oldmanId)
                })
                this.dataForm.checkold = checklist;
                this.dataForm.allOld = res.result.list;
                this.dataForm.oldList = res.result.list;
                console.log(this.dataForm)
            }
          }
      );
      //重置Rule规则
      this.$nextTick(() => {
        this.$refs["dataForm"].resetFields();
      });
    },
    submitAllForm(){
      console.log(this.dataForm);
      this.editLoading = true;
      var serviceTime = this.dataForm.serviceTime;
      if (this.dataForm.serviceTime!=null && this.dataForm.serviceTime.length == undefined) {
        serviceTime = this.formatDate(
          this.dataForm.serviceTime,
          "yyyy-MM-dd hh:mm:ss"
        );
      }

      this.dataForm.oldList.forEach(item =>{
        var info = {
          oldmanId: item.oldmanId,
          serviceId: this.dataForm.serviceId,
          serviceTime: serviceTime,
          integral: 0,
          remark: this.dataForm.remark,
          serviceDuration: this.dataForm.serviceDuration,
          serviceAddress: item.oldAddress,
        };
        console.log(info);
        this.$postJson("omc/order/apply", info)
        setTimeout(()=>{
          this.editLoading = false;
          this.dialogAllVisible = false;
          this.$message.success("下单成功");
          this.findPage();

        },10000)
      });

    },
    //查询老人
    // 显示新建界面
    handleAdd() {
      this.dialogVisible = true;
      this.operation = true;
      this.currentOlder = "";
      this.serviceContent = "";
      this.integral = "";
      this.dataForm = {
        oldName: "",
        serviceAddress: "",
        serviceTime: "",
        serviceId: "",
        serviceDuration: "",
        remark: "",
      };
      //重置Rule规则
      this.$nextTick(() => {
        this.$refs["dataForm"].resetFields();
      });
    },
    // 显示修改界面
    handleCancel(params) {
      console.log(params);
      this.$confirm("确认取消该订单吗？", "提示", {
        type: "warning",
        center: true,
      })
        .then(() => {
          if (params.row.statue == "下单" || params.row.statue == "待接单") {
            this.$postJson("omc/order/cancelById/" + params.row.id, {}).then(
              (res) => {
                if (res.code == 200) {
                  this.$message.success("取消成功");
                  this.findPage();
                } else {
                  this.$message.error(res.message);
                }
              }
            );
          } else {
            this.$message.error("该订单不存在或无法取消");
          }
        })
        .catch(() => {});
    },
    // 新建订单提交数据
    submitForm() {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          this.editLoading = true;
          console.log(this.dataForm);
          console.log(this.dataForm.serviceTime);
          console.log(this.dataForm.serviceTime.length);
          if (this.dataForm.serviceTime.length == undefined) {
            var serviceTime = this.formatDate(
              this.dataForm.serviceTime,
              "yyyy-MM-dd hh:mm:ss"
            );
          } else {
            var serviceTime = this.dataForm.serviceTime;
          }
          var info = {
            oldmanId: this.currentOlder.oldmanId,
            serviceId: this.dataForm.serviceId,
            serviceTime: serviceTime,
            integral: this.integral,
            remark: this.dataForm.remark,
            serviceDuration: this.dataForm.serviceDuration,
            serviceAddress: this.dataForm.serviceAddress,
          };
          console.log(info);
          if (info.oldmanId != undefined) {
            console.log(JSON.stringify(info));
            this.$postJson("omc/order/apply", info).then((res) => {
              console.log(res);
              if (res.code == 200) {
                this.dialogVisible = false;
                this.$refs["dataForm"].resetFields();
                this.$message.success("下单成功");
                this.findPage();
              } else {
                this.$message.error(res.message);
              }
              this.editLoading = false;
            });
          } else {
            this.editLoading = false;
            this.$message({
              type: "error",
              message: "老人姓名不存在",
            });
          }
        }
      });
    },
    formatDate(date, fmt) {
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }
      let o = {
        "M+": date.getMonth() + 1,
        "d+": date.getDate(),
        "h+": date.getHours(),
        "m+": date.getMinutes(),
        "s+": date.getSeconds(),
      };
      for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
          let str = o[k] + "";
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length === 1 ? str : ("00" + str).substr(str.length)
          );
        }
      }
      return fmt;
    },
    //查看详情
    handleLook(data) {
      console.log(data);
      let id = data.row.id;
      console.log(id);
      this.$router.push({ path: "/orderRecord", query: { id: id } }); //编程式导航跳转  query传参
    },
    //待确认
    handleNotSure(data) {
      console.log(data);
      this.$confirm("确认提交吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          console.log(data);
          let id = data.row.id;
          console.log(id);
          this.$postJson("omc/order/confirmById/" + id).then((res) => {
            this.findPage(this.filters);
            console.log(res);
            this.$message({
              type: "success",
              message: "操作成功!",
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // 时间格式化
    dateFormat(row, column, cellValue, index) {
      return format(row[column.property]);
    },
    // 处理表格列过滤显示
    initColumns() {
      this.columns = [
        { prop: "oldmanName", label: "老人姓名", minWidth: 100 },
        { prop: "serviceAddress", label: "老人地址", minWidth: 120 },
        { prop: "createdTime", label: "订单时间", minWidth: 110 },
        { prop: "serviceTime", label: "服务时间", minWidth: 110 },
        { prop: "serviceName", label: "服务名称", minWidth: 120 },
        { prop: "integral", label: "接单积分", minWidth: 100 },
        { prop: "userNameGet", label: "接单人员", minWidth: 100 },
        // {prop: "statue", label: "状态", minWidth: 100}
      ];
      this.filterColumns = JSON.parse(JSON.stringify(this.columns));
    },
    //初始化状态栏
    initialOrderStatus() {
      var orderStatus = [
        "下单",
        "待接单",
        "已接单",
        "取消接单",
        "签到",
        "签到超时",
        "签退",
        "签退超时",
        "确认",
        "确认超时",
        "接单超时",
        "取消下单",
      ];
      for (var i = 0; i < orderStatus.length; i++) {
        var item = {};
        item.value = i + 1;
        item.label = orderStatus[i];
        this.orderStatusOptions.push(item);
      }
    },
    //初始化服务时长
    initialServiceTimes() {
      let serviceTimes = [
        "1小时",
        "2小时",
        "3小时",
        "4小时",
        "5小时",
        "6小时",
        "7小时",
        "8小时",
        "9小时",
        "10小时",
        "11小时",
        "12小时",
      ];
      for (let i = 0; i < serviceTimes.length; i++) {
        const item = {};
        item.value = i + 1;
        item.label = serviceTimes[i];
        this.serviceTimeOptions.push(item);
      }
    },
  },
  created() {
    this.initialOrderStatus();
    this.initialServiceTimes();
  },
  mounted() {
    this.initColumns();
    this.findPage();
    this.getServiceList();
  },
};
</script>
<style lang="scss" scoped>
.avatar-uploader {
  width: 150px;
  height: 150px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}

.avatar {
  width: 150px;
  height: 150px;
  display: block;
}

::deep .servicecontent .el-row {
  height: 20px !important;
  line-height: 20px !important;
}

// ::deep深度作用选择符
::deep .el-dialog__header {
  text-align: left;
  background: rgb(238, 231, 231);
  border-bottom: 2px solid rgb(211, 207, 207);
}

::deep .volunteerdialog .el-dialog {
  margin-top: 60px !important;
}

::deep .volunteerdialog .el-dialog .el-dialog__body {
  padding: 30px 20px;
  height: 500px;
  overflow-y: scroll;
}

::deep .volunteerdialogform .el-form-item {
  margin-bottom: 3px;
}

//新增 编辑 dialog
@media screen and (max-width: 1599px) {
  ::deep .volunteerdialog .el-dialog {
    width: 65% !important;
  }
}
.serviceId,
.oldmanName,
.serviceAddress,
.serviceTime {
  position: relative;
}
::deep .serviceId .el-form-item__error {
  position: absolute;
  left: 71%;
  top: 30%;
}
::deep .oldmanName .el-form-item__error {
  position: absolute;
  left: 71%;
  top: 30%;
}
::deep .serviceAddress .el-form-item__error {
  position: absolute;
  left: 71%;
  top: 30%;
}
::deep .serviceTime .el-form-item__error {
  position: absolute;
  left: 71%;
  top: 30%;
}
::deep .el-scrollbar .el-scrollbar__wrap .el-scrollbar__view {
  white-space: nowrap;
  width: 100.5%;
  height: 100%;
}
::deep .el-form--inline {
  position: relative;
  z-index: 99;
}
.filtersposition {
  position: absolute;
  top: 10px;
  left: 0;
  right: 0;
  bottom: 10px;
  width: 100%;
  height: 56px;
  background: #f2f2f2;
  z-index: 1;
}
//  ::deep深度作用选择符
::deep .el-dialog__header {
  text-align: left;
  background: rgb(238, 231, 231);
  border-bottom: 2px solid rgb(211, 207, 207);
}
.oldlist ::deep .el-checkbox{
  margin-right: 5px;
  line-height: 20px;
}
</style>
